import { Dictionary } from 'lodash';

export const indexableObj: Dictionary<any> = {};
